// removed by extract-text-webpack-plugin
module.exports = {"st0":"dh-dh-orderud-menu-st0","st1":"dh-dh-orderud-menu-st1","st2":"dh-dh-orderud-menu-st2"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/common/OrderudLogo/index.css
// module id = 11
// module chunks = 0 1